/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
const getVehicleIcon = (code?: string): string => {
  const c = String(code || '').toUpperCase();
  if (c.includes('VSAV') || c.includes('SUAP')) return '🚑';
  if (c.includes('CDG') || c.includes('VLC')) return '🚓';
  if (c.includes('FPT') || c.includes('EPA') || c.includes('CCR')) return '🚒';
  return '🚐';
};

interface VehiclesModerationTabProps {
  userId: any;
  filteredItems: any;
  thCls: any;
  tdCls: any;
  editingId: any;
  editForm: any;
  setEditForm: any;
  startEdit: any;
  cancelEdit: any;
  handleSave: any;
  handleDelete: any;
  lookup: any;
  buildingOptions: any;
}

const VehiclesModerationTab: React.FC<VehiclesModerationTabProps> = ({
  userId,
  filteredItems,
  thCls,
  tdCls,
  editingId,
  editForm,
  setEditForm,
  startEdit,
  cancelEdit,
  handleSave,
  handleDelete,
  lookup,
  buildingOptions,
}) => (
        <div className="overflow-x-auto rounded border border-[#33456f]">
          <table className="w-full min-w-[1000px] border-collapse text-left">
            <thead>
              <tr>
                <th className={thCls}>ID</th>
                <th className={thCls}>Type (config)</th>
                <th className={thCls}>Nom</th>
                <th className={thCls}>Statut</th>
                <th className={thCls}>Km</th>
                <th className={thCls}>Cap.</th>
                <th className={thCls}>Coût</th>
                <th className={thCls}>Prém.</th>
                <th className={thCls}>Caserne</th>
                <th className={thCls}>Détails type</th>
                <th className={`${thCls} w-[1%]`}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredItems.map((v: any) => {
                const isEd = editingId === Number(v.id);
                return (
                  <React.Fragment key={v.id}>
                    <tr>
                      <td className={tdCls}>#{v.id}</td>
                      <td className={tdCls}>
                        {!isEd ? (
                          <>
                            {getVehicleIcon(v.vehicle_code)} {v.vehicle_type_name || v.vehicle_code || '—'}
                            <div className="text-[9px] text-slate-500">config #{v.config_vehicle_id}</div>
                          </>
                        ) : (
                          <select
                            value={editForm.config_vehicle_id || String(v.config_vehicle_id || '')}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, config_vehicle_id: e.target.value }))}
                            className="w-full max-w-[220px] rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[10px] text-slate-100"
                          >
                            {lookup.config_vehicles.length === 0 && v.config_vehicle_id != null && (
                              <option value={String(v.config_vehicle_id)}>#{v.config_vehicle_id} (chargement ref.)</option>
                            )}
                            {lookup.config_vehicles.map((cv: any) => (
                              <option key={cv.id} value={String(cv.id)}>
                                {cv.code} — {cv.nom}
                              </option>
                            ))}
                          </select>
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          v.nom
                        ) : (
                          <input
                            value={editForm.nom || ''}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, nom: e.target.value }))}
                            className="w-full min-w-[120px] rounded border border-[#33456f] bg-[#0a1329] px-1.5 py-0.5 text-[11px] text-slate-100"
                          />
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          <span className="text-slate-100">{v.vehicle_status_nom || '—'}</span>
                        ) : (
                          <select
                            value={editForm.vehicle_status_id || String(v.vehicle_status_id || '')}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, vehicle_status_id: e.target.value }))}
                            className="w-full min-w-[140px] rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[10px] text-slate-100"
                          >
                            {lookup.vehicle_statuses.length === 0 && v.vehicle_status_id != null && (
                              <option value={String(v.vehicle_status_id)}>#{v.vehicle_status_id} (ref.)</option>
                            )}
                            {lookup.vehicle_statuses.map((st: any) => (
                              <option key={st.id} value={String(st.id)}>
                                {st.nom}
                              </option>
                            ))}
                          </select>
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          v.kilometrage ?? 0
                        ) : (
                          <input
                            type="number"
                            value={editForm.kilometrage || ''}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, kilometrage: e.target.value }))}
                            className="w-20 rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[11px] text-slate-100"
                          />
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          v.capacite
                        ) : (
                          <input
                            type="number"
                            value={editForm.capacite || ''}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, capacite: e.target.value }))}
                            className="w-16 rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[11px] text-slate-100"
                          />
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          Number(v.cout ?? 0).toLocaleString('fr-FR', { minimumFractionDigits: 0 })
                        ) : (
                          <input
                            type="number"
                            step="0.01"
                            value={editForm.cout || ''}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, cout: e.target.value }))}
                            className="w-24 rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[11px] text-slate-100"
                          />
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          Number(v.premium) ? 'Oui' : 'Non'
                        ) : (
                          <select
                            value={editForm.premium || '0'}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, premium: e.target.value }))}
                            className="rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[10px] text-slate-100"
                          >
                            <option value="0">Non</option>
                            <option value="1">Oui</option>
                          </select>
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          v.batiment_nom || (v.batiment_id ? `#${v.batiment_id}` : '—')
                        ) : (
                          <select
                            value={editForm.batiment_id === undefined ? String(v.batiment_id || '') : editForm.batiment_id}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, batiment_id: e.target.value }))}
                            className="max-w-[200px] rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[10px] text-slate-100"
                          >
                            <option value="">Aucune</option>
                            {buildingOptions.map((bld: any) => (
                              <option key={bld.id} value={String(bld.id)}>
                                #{bld.id} {bld.nom}
                              </option>
                            ))}
                          </select>
                        )}
                      </td>
                      <td className={`${tdCls} text-[9px] text-slate-500`}>
                        Eau {v.capacite_eau ?? 0} / Emul. {v.capacite_emulseur ?? 0}
                        {v.specialiste ? ' · spé.' : ''} · pers. {v.capacite_personnels_min ?? 0}–{v.capacite_personnels_max ?? 0}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          <button
                            type="button"
                            onClick={() => startEdit(v)}
                            className="rounded bg-amber-600 px-2 py-0.5 text-[10px] text-white"
                          >
                            Modifier
                          </button>
                        ) : (
                          <div className="flex flex-col gap-1">
                            <button type="button" onClick={() => void handleSave(userId, v)} className="rounded bg-emerald-600 px-2 py-0.5 text-[10px] text-white">
                              Enregistrer
                            </button>
                            <button type="button" onClick={cancelEdit} className="rounded bg-slate-600 px-2 py-0.5 text-[10px] text-white">
                              Annuler
                            </button>
                          </div>
                        )}
                        <button
                          type="button"
                          onClick={() => void handleDelete('vehicles', userId, Number(v.id))}
                          className="mt-1 rounded bg-red-800 px-2 py-0.5 text-[10px] text-white"
                        >
                          Supprimer
                        </button>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
          {filteredItems.length === 0 && <p className="p-3 text-xs text-slate-400">Aucun véhicule trouvé.</p>}
        </div>
);

export default VehiclesModerationTab;
